import React, { Component } from 'react';

import "./Calendar-Months.scss"
import data from "../../../../api/data.json"

class CalendarMonths extends Component {
    constructor() {
        super();
        this.slideLeft = this.slideLeft.bind(this);
        this.slideRight = this.slideRight.bind(this);
        this.state = {
            currMonth: 0,
        }
    }
    slideRight() {
        this.setState({
            currMonth: (this.state.currMonth < 1 ? 11 : this.state.currMonth - 1)
        });
        this.props.updateBoard((this.state.currMonth < 1 ? 11 : this.state.currMonth - 1));
        this.statsClickMonth((this.state.currMonth < 1 ? 11 : this.state.currMonth - 1));
    }
    slideLeft() {
        this.setState({
            currMonth: (this.state.currMonth + 1 > 11 ? 0 : this.state.currMonth + 1)
        });
        this.props.updateBoard((this.state.currMonth + 1 > 11 ? 0 : this.state.currMonth + 1));
        this.statsClickMonth((this.state.currMonth + 1 > 11 ? 0 : this.state.currMonth + 1));
    }
    statsClickMonth(month) {
        window.dataLayer.push({
            'event': 'GA_Event',
            'Category': 'Isracard',
            'Action': 'Scroll_Clicked',
            'Label': data.calendar.months[month].name
        });
    }
    render() {
        return (
            <div className="months">
                <div className="headline">
                    <div onClick={this.slideRight} className="arrow right"></div>
                    <h4>{data.calendar.months[this.state.currMonth].name}</h4>
                    <div onClick={this.slideLeft} className="arrow left"></div>
                </div>
                <div className="desc">
                    {data.calendar.months[this.state.currMonth].desc}
                </div>
            </div>
        );
    }
}

export default CalendarMonths;



// WEBPACK FOOTER //
// ./src/components/Calendar/components/Calendar-Months/Calendar-Months.js